import * as React from 'react';

import { compose } from 'recompose';

import EditProfileForm from 'bundles/account-profile/components/EditProfileForm';
import PageFooter from 'bundles/page-footer/components/PageFooter';
import PageHeader from 'bundles/page-header/components/PageHeader';
import { CourseraMetatags } from 'bundles/seo';
import withMarketingConsent from 'bundles/user-consent/components/withMarketingConsent';

import _t from 'i18n!nls/account-profile';

const E2E_SELECTORS = {
  EDITOR_PAGE: 'profile-editor-page',
};

const AccountProfileEditorPage = () => {
  return (
    <div data-e2e={E2E_SELECTORS.EDITOR_PAGE} className="rc-AccountProfileEditorPage c-phoenix-template-page">
      <CourseraMetatags metaNameAndProperties={{ title: _t('Edit Account Profile'), disableCrawlerIndexing: true }} />
      <PageHeader
        utilizeWebRedirectOnAuthModalClose
        authModalRedirectOnCloseUrl="/"
        showLanguagesDropdown
        hideMetaNav={true}
      />
      <EditProfileForm />
      <PageFooter />
    </div>
  );
};

export default compose<{}, {}>(withMarketingConsent)(AccountProfileEditorPage);
